import React, { Component, Fragment, createRef } from "react";
import Select from "react-select";
import AppContext from "../../contexts/AppContext";
import StepsHeader from "./include/StepsHeader";
import CheckoutSteps from "./include/CheckoutSteps";
import { checkToken, updateUserWithToken } from "../../services/user";

export class ThankYou extends Component {	

	constructor() {
		super();
		this.state = {
			validToken: true,
			loading: false,
			selectedItem: 'Select',
			items: {
				how_did_you_find_us: null, 
				step: 'final',
				token_type: 'pwonbs1',
			},
			how_did_you_find_us_options: [],
			errors: {},
		}
	}

	
	componentDidMount() {
		checkToken({ token: this.props.match.params["token"], type: 'pwonbs1' })
			.then(res => {
				if (res.status === true) {
					this.setState({
						how_did_you_find_us_options: res.meta.howDidYouHear
					});
				} else {
					this.setState({ validToken: false });
				}
			})
			.catch(error => {
				this.setState({ validToken: false });
			});
	}

	handlecatSelectChange = selectedOption => {
		let temp = this.state.items;
		temp.how_did_you_find_us = selectedOption.value;
		let error = this.state.errors;
		error.how_did_you_find_us = null;
		this.setState({ items: temp, errors: error, selectedItem: selectedOption.name });
	};
	
	handleValidation = () => {
		let fields = this.state.items;
		let errors = {};
		let formIsValid = true;

		if (!fields.how_did_you_find_us) {
			formIsValid = false;
			errors.how_did_you_find_us = "The field is required.";
		}

		this.setState({ errors: errors });
		return formIsValid;
	}

	submitLearnedAbout = e => {
		e.preventDefault();
		if (this.handleValidation()) {
			this.setState({ loading: true });
			updateUserWithToken(this.state.items, this.props.match.params["token"])
				.then(res => {					
					this.setState({ loading: false });
					//this.context.state.showCodeMessage(res.message, 'success');
					localStorage.setItem("auth_token", res.meta.token);
					localStorage.setItem("user", JSON.stringify(res.data));
					window.location = "/account";
				})
				.catch(error => {
					this.setState({ loading: false });
					this.context.state.handelError(error);
				});
		}
	};
	
	render() {
		return (
            <Fragment>
                <div className="account-wrapper">
				    <StepsHeader></StepsHeader>
                    <section className="checkout pb-5">
				        <div className="container position-relative">				    	    
				    	    <CheckoutSteps onboardStep="[1,2,3,4,5]" show="5"></CheckoutSteps>
                            <div className="create-profile mx-auto mb-3">							
							    <h3 className="mb-4 text-md-center">How did you hear about ProWriter?</h3>
                                {/* <p className="mb-5 text-md-center text-dark">How did you find out about us?</p>	*/}
								<form>
								    <div className="form-group select mb-4 w-334">
									<Select 
                                               className="form-control m-input center-select" 
                                                name="how_did_you_find_us"
                                                id="how_did_you_find_us" 
                                                value={this.state.items.how_did_you_find_us}   
                                                placeholder = {this.state.selectedItem}                                            
                                                onChange={
                                                    this
                                                        .handlecatSelectChange
                                                }                                              
                                                options={
                                                    this.state.how_did_you_find_us_options
                                                }
                                            ></Select>
										
										{this.state.errors.how_did_you_find_us ? (
											<div className="invalid-feedback">
												{this.state.errors.how_did_you_find_us}
											</div>
										) : null}  
							        </div>
								</form>
							</div>
				    	    <hr className="my-5"/>
							<div className="d-flex align-items-center justify-content-center flex-md-row flex-column px-3">
								<button type="button" onClick={this.submitLearnedAbout} disabled={this.state.loading} className="btn continue btn-primary border-0 mb-md-0 mb-3"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : null}></i> {this.state.loading ? `Processing...` : `Continue`}</button>								
							</div>
						</div>		
				    </section>
				</div>	
            </Fragment>
        );
    }
}

ThankYou.contextType = AppContext;
export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/general/ThankYou.js